import { createFileRoute } from '@tanstack/react-router'
import { VerifyAppPage } from '@/features/auth'

/** `/login/verify-app` — Step 3 of 4 / returning login: authenticator TOTP. */
export const Route = createFileRoute('/login/verify-app')({
  component: VerifyAppPage,
})
